import {
  FULFILLMENT_STATUSES,
  IntegrationService,
  ORDER_METHODS,
  ORDER_PAYMENT_STATUSES,
  ROOM_SERVICE_LOCATION_TYPES,
} from '../../../../../../services/exports/Constants';
import { action_create_dummy_order, action_launch_orders_portal_app } from '../../../../../../views/sales/orders';

export default {
  title: 'Pedidos',
  buttons: {
    actions: 'Acciones',
    [action_create_dummy_order]: 'Crear pedido de prueba',
    [action_launch_orders_portal_app]: 'Abrir portal de pedidos',
    show_order_details: 'Ver detalles del pedido',
    track_order: 'Rastrear pedido',
    update_dropoff_time: 'Actualizar hora de entrega',
    download_receipt: 'Descargar recibo',
    open_payment_page: 'Abrir página de pago',
  },
  form: {
    customer_details: {
      placeholder: 'Introduce nombre o teléfono del cliente',
    },
    amount_min: {
      placeholder: 'Importe mínimo',
    },
    amount_max: {
      placeholder: 'Importe máximo',
    },
    utm_source: {
      placeholder: 'Introduce utm source',
    },
    utm_medium: {
      placeholder: 'Introduce utm medium',
    },
    utm_campaign: {
      placeholder: 'Introduce utm campaign',
    },
    utm_advertisement_id: {
      placeholder: 'Introduce id de anuncio utm',
    },
  },
  labels: {
    no_orders: 'Sin pedidos aún',
    total_orders: 'Total de pedidos',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'Recogida',
    [ORDER_METHODS.delivery]: 'Entrega',
    [ORDER_METHODS.room_service]: {
      [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Servicio de habitaciones',
      [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Servicio en mesa',
    },
  },
  payment_statuses: {
    [ORDER_PAYMENT_STATUSES.pending]: 'Pendiente',
    [ORDER_PAYMENT_STATUSES.paid]: 'Pagado',
    [ORDER_PAYMENT_STATUSES.partially_refunded]: 'Reembolso parcial',
    [ORDER_PAYMENT_STATUSES.refunded]: 'Reembolsado',
  },
  fulfillment_statuses: {
    default: {
      [FULFILLMENT_STATUSES.created]: 'Pendiente de aprobación',
      [FULFILLMENT_STATUSES.reviewed]: 'Pendiente de aprobación',
      [FULFILLMENT_STATUSES.accepted]: 'En proceso',
      [FULFILLMENT_STATUSES.preparing]: 'En proceso',
      [FULFILLMENT_STATUSES.ready]: 'En proceso',
      [FULFILLMENT_STATUSES.on_delivery]: 'En proceso',
      [FULFILLMENT_STATUSES.picked]: 'Completado',
      [FULFILLMENT_STATUSES.rejected]: 'Rechazado',
      null: 'Desconocido',
      undefined: 'Desconocido',
    },
  },
  tags: {
    dummy: 'PRUEBA',
    pickup: 'Recogida',
    internal_delivery: 'Entrega interna',
    external_delivery: 'Entrega externa',
    room_service: 'Servicio de habitaciones',
    table_service: 'Servicio en mesa',
    scheduled: 'Programado',
    reward: 'Recompensa',
    mobile: 'Móvil',
    invoice: 'Factura',
    cash: 'Efectivo',
    rejected_automatically: 'Rechazado automáticamente',
    rejected_manually: 'Rechazado manualmente',
    call_center: 'Call center',
    [IntegrationService.WinOrder]: 'WINORDER',
    [IntegrationService.ExpertOrder]: 'EXPERT ORDER',
    [IntegrationService.Deliverect]: 'DELIVERECT',
  },
  fields: {
    id: 'ID',
    company: 'Restaurante',
    tags: 'Etiquetas',
    order_placed: 'Pedido realizado',
    ready_at: 'Pedido listo',
    customer: 'Cliente',
    items: 'Artículos',
    method: 'Método',
    payment_status: 'Estado del pago',
    fulfillment_status: 'Estado',
    total: 'Total',
    utm_source: 'Fuente UTM',
    utm_medium: 'Medio UTM',
    utm_campaign: 'Campaña UTM',
    utm_advertisement_id: 'ID de anuncio UTM',
  },
  metrics: {
    total_orders: 'Total de pedidos',
  },
  toasts: {
    failed_to_load_data: 'Error al cargar los datos',
    failed_to_create_dummy_order: 'Error al crear el pedido de prueba',
    dummy_order_created: 'Pedido de prueba creado',
    failed_to_launch_orders_portal_app: 'Error al abrir el portal de pedidos',
    failed_to_download_receipt: 'Error al descargar el recibo',
  },
};
